import React, { useState } from "react";
import Bandhan_name_logo from "../assets/Images/Bandhan2.0-logo.svg";
// import FAQBackground from "../assets/Images/FAQBackground.png";
import facebook from "../assets/icons/facebook.svg";
// import Email_Icon from "../assets/icons/Emailicon.svg";
import instagram from "../assets/icons/instagram.svg";
import twitter from "../assets/icons/twitterNew.svg";
import linkedin from "../assets/icons/linkedin.svg";
import FacingIssuesIcon from "../assets/Images/FacingIssuesIcon.svg";
// import { IoCloseOutline } from "react-icons/io5";
// import { IoAddSharp } from "react-icons/io5";
import CloseIcon from "../assets/icons/CloseIcon.svg";
import ExpandIcon from "../assets/icons/ExpandIcon.svg";
import { Box } from "@mui/material";
import "./HelpFaq.css";
import "../LandingPage/Navbar.css";

import { NavLink, useNavigate } from "react-router-dom";
// import HelpFAQFooter from "./HelpFAQFooter";

const HelpFAQ = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(1);
  const [expandedCard, setExpandedCard] = useState(null);
  const [helpIframe, setHelpIframe] = useState(false);
  // const [scrollProgress, setScrollProgress] = useState(0);
  // const accordionRef = useRef(null);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const faqData = [
    {
      question: "What is the Bandhan Experience for?",
      answer:
        "The Bandhan Experience is a metaverse-based platform designed for immersive employee induction and training at Axis Max Life Insurance. It covers key topics like company values, policies, benefits, functional overview, enterprise applications with download links and allows new hires to interact virtually with leaders.",
      closeIcon: CloseIcon,
      expandIcon: ExpandIcon,
    },
    {
      question: "How do I log in to the Bandhan Experience?",
      answer:
        "You can log in to the Bandhan Experience using your Single Sign-On (SSO) ID, ensuring secure and seamless access. Please ensure once you log in, you complete the entire experience and get Bandhan 2.0 certified in the end.",
    },
    {
      question: "Who is a virtual buddy, and how do they help?",
      answer:
        "A virtual buddy is your assigned guide in the Bandhan Experience, offering support and helping you navigate through different floors and sections. In the beginning of the program, you can choose among the available options. ",
    },
    {
      question:
        "What can I expect from my digital journey on the Bandhan 2.0 experience?",
      answer:
        "During this journey, you will have a virtual tour of Axis Max Life Gurgaon 90-C and DLF offices",
      step1: "1.Learn about the company’s key values, policies, and benefits.",
      step2: "2.Engage in virtual interactions with company leaders",
      step3: "3.Participate in quizzes, trivia, and metaverse-based games.",
      step4:
        "4.Earn virtual prizes and the AMLI badge for completing activities and challenges.",
    },
    {
      question: "How long will I have access to the Bandhan Experience?",
      answer:
        "You are required to complete it within the first 72 hours of receiving the Bandhan 2.0 link. Post completion, you will continue to have access up to 60 days from your joining date, allowing you to revisit specific areas and the resource library as needed.",
    },
    {
      question: "What types of quizzes and games are available?",
      answer:
        "Each section of the experience features a learning component, enabling you to earn collectibles and unlock Axis Max Life badges at regular intervals. Engage fully with all sections to enhance your preparedness for success within the Axis Max Life.",
    },
    {
      question: "How do I get permission to access the experience?",
      answer:
        "New employees will be automatically assigned to the Bandhan 2.0 access group upon SSO ID creation. Existing employees must raise a request for access on SSO> Self Service> Bandhan 2.0.",
    },
    {
      question: "What should I do if I encounter any issues on the experience?",
      answer:
        "For technical issues or questions, please check with your HR Business Partner",
    },
    {
      question: "Can I revisit the content during the 60-day access period?",
      answer:
        "Yes, you can revisit the content and activities as many times as you like during the 60-day access period, giving you the flexibility to review and reinforce your learning.",
    },
    {
      question:
        "Will I receive a certificate of completion for this experience?",
      answer:
        "Post completion of the final quiz at the end of Bandhan experience, you will receive a Digital Certificate of Completion. Please download the certificate and keep for your reference.",
    },
    {
      question:
        "Will I be able to download the videos of the leaders and presentations featured in the Bandhan 2.0 experience?",
      answer:
        "Trying to Download videos and presentations or taking any kind of screenshots or copying from the Bandhan 2.0 experience is strictly prohibited and is against compliance and security policies of AMLI. Such actions will attract Strict Disciplinary measures.",
    },
    {
      question:
        "Which platform (mobile or PC) would be best for me to use to access the experience?",
      answer: "The experience will be accessible from both mobile and Laptop.",
    },
    {
      question: "Can I login from multiple devices?",
      answer:
        "It is recommended that you log in from one device at a time. In case of multiple active sessions on different devices, your progress will not be saved and the sessions will not be counted.",
    },
  ];

  const handleCardClick = (index) =>
    setExpandedCard(expandedCard === index ? null : index);
  return (
    <>
      {!helpIframe ? (
        <>
          <div className="Bandhan-faq-page-container">
            <header className="header">
              <div className="container">
                <img
                  onClick={() => {
                    navigate("/");
                  }}
                  className="logo"
                  src={Bandhan_name_logo}
                  alt="Bandhan_name_logo"
                />

                <input className="menu-btn" type="checkbox" id="menu-btn" />
                <label className="menu-icon" htmlFor="menu-btn">
                  <span className="navicon"></span>
                </label>
                <ul className="menu">
                  <li>
                    <NavLink
                      onClick={() => {
                        handleTabChange(1);
                      }}
                      to="/helpfaqs"
                      className={`tab ${activeTab === 1 ? "active" : ""}`}
                    >
                      Help & FAQs
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/aboutbandhan">About Bandhan</NavLink>
                  </li>

                  <li>
                    <button
                      onClick={() => setHelpIframe(true)}
                      className="start-now-buttons"
                    >
                      Start Now
                    </button>
                  </li>
                </ul>
              </div>
            </header>

            <div className="faq-Bandhan-data-card">
              <h1 className="Faq-heading">
                Frequently <br /> asked questions
              </h1>
              <div className="faq-email-alignment">
                <div className="faq-card-container">
                  {faqData.map((faq, index) => (
                    <div key={index} className="faqCards">
                      <div onClick={() => handleCardClick(index)}>
                        <div className="arrow-question-alignment">
                          <h1 className="questionText">{faq.question}</h1>
                          {expandedCard === index ? (
                            // <IoCloseOutline className="questionIcon" />
                            <img
                              className="questionIcon"
                              src={CloseIcon}
                              alt="CloseIcon"
                            />
                          ) : (
                            // <IoAddSharp className="answerIcon" />
                            <img
                              className="answerIcon"
                              src={ExpandIcon}
                              alt="ExpandIcon"
                            />
                          )}
                        </div>
                      </div>
                      {expandedCard === index && (
                        <Box>
                          {faq.answer && (
                            <div>
                              <h1 className="answerText">{faq.answer}</h1>
                              <p className="Faq-steps">{faq.step1}</p>
                              <p className="Faq-steps">{faq.step2}</p>
                              <p className="Faq-steps">{faq.step3}</p>
                              <p className="Faq-steps faq-step4">{faq.step4}</p>
                            </div>
                          )}
                        </Box>
                      )}
                    </div>
                  ))}
                </div>
                <div className="facing-issues-card">
                  <h1 className="facing-issues-heading">
                    Facing Issues? Contact your
                  </h1>
                  <h1 className="facing-issues-heading facing-issues-heading3">
                    HR Business Partner
                  </h1>
                  <h1 className="facing-issues-heading facing-issues-heading3">
                    <a href="https://cars2.maxlifeinsurance.com/MDLIncidentMgmt/EndUser_Dashboard.aspx" target="_blank" rel="noopener noreferrer">Click here to raise the issue</a>
                  </h1>

                  <img
                    className="facingissue"
                    src={FacingIssuesIcon}
                    alt="FacingIssuesIcon"
                  />
                </div>
              </div>
            </div>

            <footer className="section bg-footer">
              <div className="footer-section-icons">
                <a
                  href="https://x.com/AxisMaxLifeIns"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    className="footer-icons-alignment"
                    src={twitter}
                    alt="twitter"
                  />
                </a>

                <a
                  href=" https://facebook.com/AxisMaxLife/"
                  target="_blank"
                  rel="noopener"
                >
                  <img
                    className="footer-icons-alignment"
                    src={facebook}
                    alt="facebook"
                  />
                </a>
                <a
                  href="https://www.instagram.com/axis_max_life_insurance/?hl=en"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    className="footer-icons-alignment"
                    src={instagram}
                    alt="instagram"
                  />
                </a>

                <a
                  href=" https://www.linkedin.com/company/axis-max-life-insurance-limited/"
                  target="_blank"
                  rel="noopener"
                >
                  <img
                    className="footer-icons-alignment"
                    src={linkedin}
                    alt="linkedin"
                  />
                </a>
              </div>
            </footer>
          </div>
          <div className="facing-issues-card-mobile">
            <h1 className="facing-issues-heading">
              Facing Issues? Contact your
            </h1>
            <h1 className="facing-issues-heading facing-issues-heading2">
              HR Business Partner
            </h1>
            <h1 className="facing-issues-heading facing-issues-heading3">
                    <a href="https://cars2.maxlifeinsurance.com/MDLIncidentMgmt/EndUser_Dashboard.aspx" target="_blank" rel="noopener noreferrer">Click here to raise the issue</a>
                  </h1>

            <img src={FacingIssuesIcon} alt="logo" />
          </div>
          <div className="Bandhan-landing-page-logo-container">
            <a
              href="https://x.com/AxisMaxLifeIns"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img className="icons-alignment" src={twitter} alt="twitter" />
            </a>

            <a
              href=" https://facebook.com/AxisMaxLife/"
              target="_blank"
              rel="noopener"
            >
              <img className="icons-alignment" src={facebook} alt="facebook" />
            </a>
            <a
              href="https://www.instagram.com/axis_max_life_insurance/?hl=en"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                className="icons-alignment"
                src={instagram}
                alt="instagram"
              />
            </a>

            <a
              href=" https://www.linkedin.com/company/axis-max-life-insurance-limited/"
              target="_blank"
              rel="noopener"
            >
              <img className="icons-alignment" src={linkedin} alt="linkedin" />
            </a>
          </div>
        </>
      ) : (
        <iframe
          title="Bandhan Landing Page"
          width="100%"
          height="100%"
          id=""
          src="https://maxlife.gmetri.com/bandhan2"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; microphone; camera; display-capture; xr-spatial-tracking; xr;"
          frameborder="0"
          allowfullscreen
        ></iframe>
      )}
    </>
  );
};

export default HelpFAQ;
